import React from 'react';
import { default as View } from './View';

export const Error = props => {
    return <View {...props} />;
};
